import ServiceProductOrderList from "@/views/serviceproducts/Index";
import ServiceProductOrderAdd from "@/views/serviceproducts/Add";
import ServiceProductOrderDetail from "@/views/serviceproducts/Detail";

export default [
  {
    path: "orders",
    name: "orders",
    component: ServiceProductOrderList,
    meta: {
      title: "Bestellingen"
    }
  },
  {
    path: "orders-add",
    name: "ordersAdd",
    component: ServiceProductOrderAdd,
    meta: {
      title: "Nieuwe bestelling"
    }
  },
  {
    path: "orders/:id",
    name: "ordersDetail",
    component: ServiceProductOrderDetail,
    meta: {
      title: "Bestelling"
    }
  }
];
